import { submitV2AnalyticsEvent } from "../analyticsUtils";

function dispatchAddToCartSubmitted(
  productCode,
  productName,
  itemQuantity,
  itemValue,
  stockAvailabilityStatus,
) {
  submitV2AnalyticsEvent("Add Product to Cart", {
    originID: null,
    origin: "PDP",
    originType: null,
    lineItemCount: 1,
    productCode,
    productName,
    itemQuantity,
    itemValue,
    isPunchout: "No",
    stockAvailability: stockAvailabilityStatus,
    searchId: sessionStorage.getItem("searchId"),
    rank: sessionStorage.getItem("rank"),
    pageNumber: sessionStorage.getItem("pageNumber"),
    searchTerm: sessionStorage.getItem("searchTerm"),
  });
}

export function addToCart(event, price, productName, stockAvailabilityStatus) {
  event.preventDefault();
  const itemQuantity = getProductQuantity();
  const totalPrice = price ? parseFloat(price) * parseFloat(itemQuantity) : 0;
  dispatchAddToCartSubmitted(
    getProductDetailsCode(),
    productName,
    itemQuantity,
    totalPrice,
    stockAvailabilityStatus,
  );
}

function getProductDetailsCode() {
  const anchorTag = document.getElementById("product-detail-page");
  return anchorTag ? anchorTag.getAttribute("data-product-code") : null;
}

function getProductQuantity() {
  const anchorTag = document.getElementById("pdp-product-qty");
  return anchorTag ? anchorTag.getAttribute("value") : null;
}
